import { axios } from '@/utils/request'

export function insertAdTrafficList(parameter = {}) {
  return axios({
    url: '/statistics/insertAdTrafficList',
    method: 'post',
    data: parameter
  })
}

export function queryAdTrafficList (parameter = {}) {
  return axios({
    url: '/statistics/queryAdTrafficList',
    method: 'post',
    data: parameter
  })
}

